import React from 'react';
import {
    // Theme,
    theme,
    actionTheme
} from "./theme/index";
import Svg from './svg/index';
import Button from './button/buttonField';
import Dialog from './dialog/dialog';
import {
    GlobalLoading,
    PartLoading
} from './loding/index';

import Page from './page/page';
import {
    GridField,
    Tr,
    Td,

    gridRows,
    selectFlag,
    selectItem,
    selectAll,

    actionGrid,
} from './grid/index';

import ScrollBox from './scroll/scroll';
import {
    InputField,
    TextareaField,
    RadioField,
    CheckboxField,
    SelectField,
    SelectCheckboxField,
    SelectLenovoField,
    SelectLenovoCheckboxField,
    DateField,
    DateRangeField,
    DateWeekField,
    OrganizationTreeField,

    formData,
    subVerifyRes,
    actionForm
} from "./form/index";

import {
    Personnel,

    personnelList,
    choosePerson,

    actionPerson
} from "./person/index";

import TableField from "./table/table";

import {_Platform, _Cache, _Ajax, _Tree, _Object, _Date, _Array,} from  "./utils/utils";
const _utils = {_Platform, _Cache, _Ajax, _Tree, _Object, _Date, _Array,};

export {
    //主题
    theme,//store
    actionTheme,//action

    //图标
    Svg,
    //按钮
    Button,
    //弹框
    Dialog,

    //全局loading
    GlobalLoading,
    //局部loading
    PartLoading,

    //分页
    Page,

    //grid
    GridField,
    Tr,
    Td,
    gridRows,//store
    selectFlag,//store
    selectItem,//store
    selectAll,//store
    actionGrid,//action

    //滚动条
    ScrollBox,

    //表单
    InputField,
    TextareaField,
    RadioField,
    CheckboxField,
    SelectField,
    SelectCheckboxField,
    SelectLenovoField,
    SelectLenovoCheckboxField,
    DateField,
    DateRangeField,
    DateWeekField,
    OrganizationTreeField,
    formData,//store
    subVerifyRes,//store
    actionForm,//action

    //选择人员
    Personnel,
    personnelList,//store
    choosePerson,//store
    actionPerson,//action


    //表格
    TableField,

    _utils,


}